import { render, staticRenderFns } from "./BrigadeMapClosestTasks.vue?vue&type=template&id=0d3104d4&"
import script from "./BrigadeMapClosestTasks.vue?vue&type=script&lang=js&"
export * from "./BrigadeMapClosestTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBanner,QIcon} from 'quasar'
component.options.components = Object.assign({QBanner,QIcon}, component.options.components || {})
